import executeSearchService from 'mini-execute-mail-search-service/lib/services/executeSearchService';
import isItemView from 'owa-mail-store/lib/utils/isItemView';
import ItemTypesFilter from 'owa-service/lib/contract/ItemTypesFilter';
import SearchTableQuery from 'mini-mail-list-store/lib/store/schema/SearchTableQuery';
import { doesExecuteSearchResponseHasError } from 'mini-execute-mail-search-service/lib/utils/doesExecuteSearchResponseHasError';
import { getMailSearchResultsFromExecuteSearchResponse } from './getMailSearchResultsFromResponse';
import { MAIL_QUERY_PAGE_SIZE } from 'mini-3s-service/lib/utils/constants';
import { MailSearchResults } from '../store/schema/MailSearchResults';

/**
 * Returns a promise which resolves when executeSearch service completes.
 * An object containing the mail results are returned when the promise resolves.
 * @param searchTableQuery
 */
export const getExecuteSearchResults = async (
    searchTableQuery: SearchTableQuery
): Promise<MailSearchResults> => {
    const itemTypes: ItemTypesFilter = isItemView() ? 'MailItems' : 'MailConversations';

    const { queryString, rowOffset, searchSessionGuid, searchFolderScopeId } =
        searchTableQuery ?? {};

    const response = await executeSearchService({
        rowOffset: rowOffset,
        pageSize: MAIL_QUERY_PAGE_SIZE,
        queryString: queryString,
        sessionGuid: searchSessionGuid,
        staticFolderScopeId: searchFolderScopeId,
        itemTypes,
    });

    /** If there is an error, handle it here */
    if (doesExecuteSearchResponseHasError(response)) {
        return {
            hasError: true,
            areMoreResultsAvailable: false,
            rows: [],
        };
    }

    /** If no error, get the results from response */
    return getMailSearchResultsFromExecuteSearchResponse(response, itemTypes);
};
